<section>
  <ol>
    @for (item of dataSignal(); track $index; let last = $last) {
    <li class="font-size-16 font-weight-regular" [ngClass]="{ 'line-text': !last }">
      {{ item.title }}
      <ul>
        @for (sub of item.subtitle; track $index) {
        <li class="font-size-16 font-weight-regular">
          {{ sub.headers }}
        </li>
        }
      </ul>
    </li>
    }
  </ol>
</section>
